import { IsBoolean, IsNotEmpty, IsOptional } from "class-validator";
import { IsString } from "class-validator";

export class FindOneSurveyDto {
  @IsString()
  @IsOptional()
  buildProjectId?: string;

  @IsString()
  @IsOptional()
  accountId?: string;

  /**
   * The design project the client is onboarding. Lets the API tailor question
   * content to the project's package (see onboarding variants) without the
   * caller knowing which packages differ.
   */
  @IsString()
  @IsOptional()
  designProjectId?: string;

  @IsString()
  @IsNotEmpty()
  surveyKey!: string;

  @IsBoolean()
  @IsOptional()
  isPublic?: boolean;
}
